export const twoColumnArrayFormatter = <T>(items: Array<T>, width: number): Array<Array<T>> => {
    if (width >= 1024) {
        const odd = items.filter((el, index) => (index + 1) % 2 !== 0);
        const even = items.filter((el, index) => (index + 1) % 2 === 0);

        return [odd, even];
    } else {
        return [items];
    }
};

export const twoColumnObjectFormatter = (data: Record<string, any>, width: number): Array<Array<string>> => {
    const items = Object.keys(data);
    return twoColumnArrayFormatter(items, width);
};
